import React from 'react';

import styled from 'styled-components';

import { Currency, FormattedMessage } from '@techstyle/react-intl';

type ProductPriceProps = {
  memberPrice: number;
  guestPrice: number;
  isPdp?: boolean;
  isVip?: boolean;
  isGshopActive?: boolean;
};

const ProductPriceWrapper = styled.div`
  ${props => props.theme.paragraph.variants.paragraph3Uppercase.textStyles}
  line-height: 18px;
`;

export const MemberPrice = styled.div<{ isPdp?: boolean }>`
  display: flex;
  ${({ isPdp }) => isPdp && 'justify-content: space-between;'}
  ${({ isPdp }) => isPdp && 'font-size: 16px;'}
  color: ${({ theme }) => theme.colors.black};
  padding: 4px 0;
  text-transform: uppercase;
  font-weight: 600;
`;

export const GuestPrice = styled.div<{ isPdp?: boolean }>`
  color: ${({ theme }) => theme.colors.gray500};
  display: flex;
  ${({ isPdp }) => isPdp && 'justify-content: space-between;'}

  text-transform: uppercase;
`;

const Price = styled.span<{ isVip?: boolean }>`
  ${({ isVip }) => !isVip && 'margin-left: 6px;'}
`;

export const ProductPrice = ({
  memberPrice,
  guestPrice,
  isVip,
  isPdp,
  isGshopActive,
}: ProductPriceProps) => {
  if (isVip) {
    return (
      <ProductPriceWrapper>
        <MemberPrice isPdp={isPdp}>
          {isPdp && (
            <FormattedMessage
              id="site_pdp.member_new_price_label"
              defaultMessage="Members:"
            />
          )}
          <Price isVip={isVip}>
            <Currency
              amount={memberPrice}
              currencyDisplay="symbol"
              maximumFractionDigits={2}
              minimumFractionDigits={2}
              trimZeros
              useGrouping
            />
          </Price>
        </MemberPrice>
      </ProductPriceWrapper>
    );
  }

  return (
    <ProductPriceWrapper>
      {!isGshopActive ? (
        <MemberPrice isPdp={isPdp}>
          <FormattedMessage
            id="site_pdp.member_new_price_label"
            defaultMessage="Members:"
          />
          <Price>
            <Currency
              amount={memberPrice ?? 0}
              currencyDisplay="symbol"
              maximumFractionDigits={2}
              minimumFractionDigits={2}
              trimZeros
              useGrouping
            />
          </Price>
        </MemberPrice>
      ) : null}
      <GuestPrice isPdp={isPdp}>
        <FormattedMessage
          id="site_pdp.guest_new_price_label"
          defaultMessage="Guests:"
        />
        <Price>
          <Currency
            amount={(isGshopActive ? memberPrice : guestPrice) ?? 0}
            currencyDisplay="symbol"
            maximumFractionDigits={2}
            minimumFractionDigits={2}
            trimZeros
            useGrouping
          />
        </Price>
      </GuestPrice>
    </ProductPriceWrapper>
  );
};
